<app-company-info
  [companyInitials]="companyInitials"
  [company]="company"
></app-company-info>
<mat-card>
  <mat-card-content>
    <div class="header-wrapper">
      <div class="header-wrapper-left-button">
        <button aria-label="collapse" mat-button="" (click)="_location.back()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <div>
          @if (isEqual(this.status, 'Active')) {
          <span class="mat-h2">{{ header }}</span>
          }
          @if (isEqual(this.status, 'Inactive')) {
          <span class="mat-h2">{{header}}(Closed)</span>
          }
        </div>
      </div>
      <div class="header-wrapper-right-button">
        <div class="closed-btn" [matTooltip]="(isEqual(this.status, 'Inactive'))?('COMPANY_BRANCHES.tooltip'|translate) : ('Add_users_to_branches'|translate)">
        <button
         [disabled]="isEqual(this.status, 'Inactive')"
          mat-stroked-button
          color="primary"
          aria-label="plus"
          mat-button
          (click)="addUsers()"
        >
          <mat-icon>add</mat-icon>
          <span>{{ 'APP_DETAILS.add_users_title' | translate}}</span>
        </button>
      </div>
        <div class="closed-btn" [matTooltip]="this.selection.hasValue()?('Remove_users_from_branches' | translate) : ('Remove_User_Disabled' | translate)">
          <button
          mat-stroked-button
          color="primary"
          aria-label="trash"
          mat-button
          (click)="deleteUsers()"
          [disabled]="!this.selection.hasValue()"
        >
          <mat-icon>delete_outline</mat-icon>
          <span>{{ 'COMPANY_DETAILS_HEADER.remove_users' | translate }}</span>
        </button>
        </div>
        <div>
          <mat-form-field floatLabel="always" appearance="outline" >
            <mat-label class="mat-label">{{
              'SEARCH.search' | translate
            }}</mat-label>
            <input
              id="search"
              #search
              matInput
              (keyup)="monitorSearch(search.value)"
              [placeholder]="'USERS_SEARCH.search_placeholder' | translate"
            />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
      </div>
    </div>
    @if (noRecordFound) {
    <app-not-found
      [displayMessage]="message"
    ></app-not-found>
    }

    <table
      mat-table
      [dataSource]="usersDataSource"
      [ngClass]="noRecordFound ? 'hide' : ''"
      matSort
    >
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            color="primary"
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="isPartiallySelected()"
            [disabled]="usersDataSource === undefined || getSelectableRows().length === 0"            
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <div [matTooltip]="row.branchAssignments?.length === 1 ? ('Remove_All_Branch_Assignments' | translate)  : ''"> 
            <mat-checkbox
              color="primary"
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
              [disabled]="row.branchAssignments?.length === 1"
            >
            </mat-checkbox>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'COMPANY_USERS.name' | translate }}
        </th>
        <td mat-cell *matCellDef="let user">
          {{ user.name }}
          @if (user.isCompanyAdmin) {
          <mat-chip class="company-admin">{{
            'COMPANY_ADD_USERS.admin' | translate | uppercase
          }}</mat-chip>
          }
          @if (isBranchAdmin(user)) {
          <mat-chip class="branch-admin">
            {{'COMPANY_ADD_USERS.branch_admin' | translate | uppercase}}
          </mat-chip>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'COMPANY_USERS.email' | translate }}
        </th>
        <td mat-cell *matCellDef="let user">{{ user.email }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>
    @if (!noRecordFound) {
    <mat-paginator
      [showFirstLastButtons]="true"
      [pageSizeOptions]="[10, 25, 50, 100]"
    ></mat-paginator>
    }
  </mat-card-content>
</mat-card>
@if (_changeBranchesService.loading) {
<app-spinner></app-spinner>
}
